<template>
  <div :class="['message_handle',{'show': hasReChoose}]">
    <!-- 重新选择 -->
    <div
      class="handle_box choose"
      @click="$emit('reChoose', item)"
      v-if="hasReChoose"
    >
      <span>重新选择</span>
    </div>
    <template v-if="item.id">
      <!-- 添加到短信输入框 -->
      <div class="handle_box" @click="$emit('add', item)" v-if="type">
        <el-tooltip content="添加到短信输入框" placement="top">
          <div>
            <img
              class="message_icon"
              :src="cdnUrl + 'ai-add-message.svg'"
              alt=""
            />
            <img
              class="message_icon_hover"
              :src="cdnUrl + 'ai-add-message-hover.svg'"
              alt=""
            />
          </div>
        </el-tooltip>
      </div>

      <!-- 复制 -->
      <div
        v-else-if="!hideCopy && !type"
        class="handle_box"
        v-clipboard:copy="copyText"
        v-clipboard:success="onCopy"
        v-clipboard:error="onError"
      >
        <el-tooltip content="复制" placement="top">
          <div>
            <img class="message_icon" :src="cdnUrl + 'ai-copy.svg'" alt="" />
            <img
              class="message_icon_hover"
              :src="cdnUrl + 'ai-copy-hover.svg'"
              alt=""
            />
          </div>
        </el-tooltip>
      </div>

      <!-- 喜欢 -->
      <div
        class="handle_box"
        @click="handleLike(item)"
        v-if="showLikeAndUnlike"
      >
        <el-tooltip content="喜欢" placement="top">
          <div v-if="likeStatus">
            <img
              class="message_icon_active"
              :src="cdnUrl + 'ai-like-active.svg'"
              alt=""
            />
          </div>
          <div v-else>
            <img class="message_icon" :src="cdnUrl + 'ai-like.svg'" alt="" />
            <img
              class="message_icon_hover"
              :src="cdnUrl + 'ai-link-hover.svg'"
              alt=""
            />
          </div>
          <img
            class="message_icon"
            :src="cdnUrl + 'ai-like-active.svg'"
            alt=""
          />
        </el-tooltip>
      </div>

      <!-- 不喜欢 -->
      <div
        class="handle_box"
        @click="handleUnlike(item)"
        v-if="showLikeAndUnlike"
      >
        <el-tooltip content="不喜欢" placement="top">
          <div v-if="dislikeStatus">
            <img
              class="message_icon_active"
              :src="cdnUrl + 'ai-unlike-active.svg'"
              alt=""
            />
          </div>
          <div v-else>
            <img class="message_icon" :src="cdnUrl + 'ai-unlike.svg'" alt="" />
            <img
              class="message_icon_hover"
              :src="cdnUrl + 'ai-unlink-hover.svg'"
              alt=""
            />
          </div>
        </el-tooltip>
      </div>

      <!-- 重新生成 -->
      <div
        class="handle_box"
        :class="{ forbidden: isCreating }"
        @click="$emit('regenerate', item)"
        v-if="showRegenerate"
      >
        <el-tooltip content="重新生成" placement="top">
          <div>
            <img class="message_icon" :src="cdnUrl + 'ai-refresh.svg'" alt="" />
            <img
              class="message_icon_hover"
              :src="cdnUrl + 'ai-refresh-hover.svg'"
              alt=""
            />
          </div>
        </el-tooltip>
      </div>
    </template>
  </div>
</template>

<script>
import { likeAndStep } from "@/api/ai/newAi.js";

export default {
  name: "ChatMessageActions",
  props: {
    item: {
      type: Object,
      required: true,
    },
    copyText: {
      type: String,
      default: "",
    },
    type: {
      type: Number,
      default: 0,
    },
    showLikeAndUnlike: {
      type: Boolean,
      default: true,
    },
    isLike: {
      type: Boolean,
      default: false,
    },
    isUnlike: {
      type: Boolean,
      default: false,
    },
    isCreating: {
      type: Boolean,
      default: false,
    },
    showRegenerate: {
      type: Boolean,
      default: true,
    },
    // 重新选择操作
    hasReChoose: {
      type: Boolean,
      default: false,
    },
    hideCopy: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      cdnUrl: "https://cdn-image.yucrm.cn/images/tb-front-platform/images/ai/",
      likeStatus: false,
      dislikeStatus: false,
    };
  },
  watch: {
    isLike: {
      handler(newVal) {
        this.likeStatus = newVal;
      },
      immediate: true,
    },
    isUnlike: {
      handler(newVal) {
        this.dislikeStatus = newVal;
      },
      immediate: true,
    },
  },
  methods: {
    handleAdd(item) {
      this.$emit("add", item);
    },
    onCopy() {
      this.$message.success("复制成功");
    },
    onError() {
      this.$message.error("复制失败");
    },
    handleLike(item) {
      const query = {
        chatId: item.id,
        likeStatus: this.likeStatus ? false : true,
        dislikeStatus: false,
      };
      likeAndStep(query).then((res) => {
        if (res.code === 200) {
          this.likeStatus = query.likeStatus;
          this.dislikeStatus = false;
        }
      });
      this.$emit("like", item);
    },
    handleUnlike(item) {
      const query = {
        chatId: item.id,
        likeStatus: false,
        dislikeStatus: this.dislikeStatus ? false : true,
      };
      likeAndStep(query).then((res) => {
        if (res.code === 200) {
          this.likeStatus = false;
          this.dislikeStatus = query.dislikeStatus;
        }
      });
      this.$emit("unlike", item);
    },
  },
};
</script>

<style lang="scss" scoped>
.show {
  display: block !important;
}
.message_handle {
  position: absolute;
  left: 0;
  bottom: -30px;
  width: 100%;
  font-size: 12px;
  white-space: pre;
  display: none;

  .handle_box {
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-right: 12px;

    &:hover {
      .message_icon {
        display: none;
      }

      .message_icon_hover {
        display: inline-block;
      }
    }

    .message_icon_active {
      width: 20px;
      height: 20px;
    }

    .message_icon {
      width: 20px;
      height: 20px;
    }

    .message_icon_hover {
      width: 20px;
      height: 20px;
      display: none;
    }

    span {
      display: inline-block;
      white-space: pre;
    }

    @keyframes rotate {
      from {
        transform: rotate(0deg);
      }

      to {
        transform: rotate(360deg);
      }
    }
  }

  .forbidden {
    cursor: not-allowed;
  }
}
.choose {
  color: #3159ff;
  margin-top: -4px;
}
</style>